export const oscColor = "#333"
export const restColor = "#070707"
